import { getCommerceApiClient } from './commerceApiClient';

const MAX_AGE_MS = 30_000;
let currentRequest;

/** Clear header-only data when the account session ends. */
export function clearCdsMenuProfile() {
  currentRequest = undefined;
}

/**
 * Share the live header lookup across mobile/desktop mounts and short navigation.
 * Checkout quotes never use this cache. Nothing is persisted to browser storage.
 * @param {string} scope - Tenant, account and session identity.
 * @param {string|null} refreshKey - Completed purchase that requires a fresh balance.
 * @returns {Promise<object>} Current profile, or the provider rejection.
 */
export function getCdsMenuProfile(scope, refreshKey = null) {
  if (
    currentRequest?.scope === scope &&
    Date.now() < currentRequest.expiresAt &&
    (refreshKey == null || currentRequest.refreshKey === refreshKey)
  ) {
    return currentRequest.promise;
  }
  const request = { scope, refreshKey, expiresAt: Date.now() + MAX_AGE_MS };
  request.promise = Promise.resolve()
    .then(() => getCommerceApiClient().accounts.getCdsPassengerProfile())
    // Category is stored account metadata and remains available during a balance outage.
    .catch(() => getCommerceApiClient().accounts.getCdsPassengerProfile({ includeBalance: false }))
    .catch((error) => {
      if (currentRequest === request) currentRequest = undefined;
      throw error;
    })
    .finally(() => {
      request.expiresAt = Date.now() + MAX_AGE_MS;
    });
  currentRequest = request;
  return request.promise;
}
